import { createSlice } from "@reduxjs/toolkit";
import { Vm_ContaBancoModel } from "../../../models/contaBanco/vm_contaBancoModel";
import { buscarContaBanco } from "../../../services/contaBancoService";
import { resetAll } from "../../actions/actions";
import { BuscarContaBancoModel } from "../../../models/contaBanco/buscarContaBancoModel";

export interface ContaBancoState {
  //buscar conta banco
  loading: boolean;
  busca: BuscarContaBancoModel;
  list: Vm_ContaBancoModel[];
  entity: Vm_ContaBancoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
  modalDeletarSaldoInicioContaBanco: boolean;
}

const initialState: ContaBancoState = {
  //buscar conta banco
  loading: false,
  busca: {
    pesquisar: null,
    id: null,
    idEmpresa: null,
  } as BuscarContaBancoModel,
  list: [],
  entity: {} as Vm_ContaBancoModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
  modalDeletarSaldoInicioContaBanco: false,
};

export const contaBancoSlice = createSlice({
  name: "contaBanco",
  initialState,
  reducers: {
    //buscar conta banco
    setBuscaContaBanco: (state, action) => {
      state.busca = action.payload;
    },
    setEntityContaBanco: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarContaBanco: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarContaBanco: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setModalDeletarSaldoInicioContaBanco: (state, action) => {
      state.modalDeletarSaldoInicioContaBanco = action.payload;
    },
    resetContaBanco: () => initialState,
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar conta banco
    builder.addCase(buscarContaBanco.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarContaBanco.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarContaBanco.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar conta banco
  setBuscaContaBanco,
  setEntityContaBanco,
  //internal
  setModalCadastrarContaBanco,
  setModalDeletarContaBanco,
  setModalDeletarSaldoInicioContaBanco,
  resetContaBanco,
} = contaBancoSlice.actions;

export default contaBancoSlice.reducer;
